module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-switch"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Switch")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('div', {
    staticClass: "page-switch"
  }, [_c('div', {
    staticClass: "page-switch__wrapper"
  }, [_c('zan-switch', {
    staticClass: "some-customized-class",
    attrs: {
      "checked": _vm.switchState,
      "on-change": _vm.updateState
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-switch__text"
  }, [_vm._v(_vm._s(_vm.switchStateText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-switch__wrapper"
  }, [_c('zan-switch', {
    staticClass: "some-customized-class",
    attrs: {
      "checked": true,
      "disabled": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-switch__text"
  }, [_vm._v("ON, DISABLED")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-switch__wrapper"
  }, [_c('zan-switch', {
    staticClass: "some-customized-class",
    attrs: {
      "checked": false,
      "disabled": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-switch__text"
  }, [_vm._v("OFF, DISABLED")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7f13822!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/switch.vue
// module id = 261
// module chunks = 0